import { Loading } from "@nextui-org/react";

const PageLoading = () => {
  return (
    <div className="w-full flex justify-center mt-20">
      <Loading size="xl" />
    </div>
  );
};

export default PageLoading;
